export default {
  independentMarketing: {
    common: {
      requestFailed: "Échec de la demande d'interface",
      hintSelect: 'Sélectionnez',
      hintInput: 'Saisissez',
      submit: 'Soumettre',
      cancel: 'Annuler',
      confirm: 'OK',
    },
    agreement: {
      title: "Accord d'enregistrement de revendeur indépendant Autel",
      nextBtn: 'Suivant',
      getAgreementFailed: "Impossible d'obtenir le contenu de l'accord.",
    },
    successPage: {
      title:
        "Les informations de votre candidature ont été soumises avec succès et les résultats de l'examen seront envoyés à votre adresse e-mail $1 dans les 15 jours ouvrables. Veuillez vérifier votre boîte de réception pour plus d'informations.",
      subTitle: "Revenez à la page d'accueil après $1 seconde(s).",
    },
    applyTitle:
      'Vous postulez pour devenir revendeur indépendant Autel. Merci de renseigner avec précision les informations suivantes:',
    companyName: "Nom de l'entreprise",
    companyTax: 'VAT ID',
    userCountry: 'Pays',
    legalPerson: 'Conseiller juridique',
    contactEmail: 'Email du contact',
    contactEmailTips:
      "Cette adresse e-mail sera votre contact pour l'e-mail du résultat de l'examen. Une fois l'examen approuvé, il sera également utilisé comme nom de compte de connexion pour le système de gestion des concessionnaires indépendants.",
    corporateIdentity: 'ID du conseiller juridique',
    uploadTips: 'JPG, JPEG, PNG, PDF (pas plus de 20 MB)',
    businessLicense: "Licence d'exploitation",
    emailErrorTips: 'Entrer un email valide.',
    uploadPic: 'Importer des images',
    picMaxLimit: 'La taille maximale des images est de 20 MB. Veuillez sélectionner à nouveau.',
  },
};
